import CertificationRegistry from "../CertificationRegistry";
import { hasPermission } from "../../permissions";

export default function ShipperCertifications({ supplierId, lang, profile }) {
  return (
    <CertificationRegistry
      lang={lang}
      lockSupplierId={supplierId}
      canCreate={hasPermission(profile, "create_certifications")}
      canEdit={hasPermission(profile, "edit_certifications")}
      canDelete={hasPermission(profile, "delete_certifications")}
    />
  );
}
